import { AsyncStorage } from "react-native"

export class LocalStorage {
    storage: AsyncStorage;
    storageKey: string;
    constructor(storageKey: string) {
        this.storage = AsyncStorage;
        this.storageKey = storageKey;
    }

    async setItem(itemKey: string, value: string | any): Promise<boolean> {
        try {
            console.log(`if (typeof value === typeof 'chars') ==> ${typeof value === typeof 'chars'}`);
            if (typeof value === typeof 'chars') {
                await this.storage.setItem(this.storageKey + itemKey, value);
            }
            else {
                await this.storage.setItem(this.storageKey + itemKey, JSON.stringify({ ...value }));
            }
            return true;
        } catch (error) {
            console.log('LocalStorage error: ', error);
            return false;
        }
    }

    async getItem(itemKey: string): Promise<string> {
        try {
            const data: string = await this.storage.getItem(this.storageKey + itemKey);
            console.log(`Looking for ${itemKey} using ${this.storageKey} found data = ${data}`);
            return data;
        } catch (error) {
            console.log('LocalStorage error: ', error);
            return undefined;
        }
        // return result;
    }

    async removeItem(itemKey: string): Promise<boolean> {
        try {
            await this.storage.removeItem(this.storageKey + itemKey);
            return true;
        } catch (error) {
            console.log('LocalStorage error: ', error);
            return false;
        }
    }
}

export const localStorage: LocalStorage = new LocalStorage('poall' + '.');